import { render, staticRenderFns } from "./CountriesPage.vue?vue&type=template&id=4588f2be&"
import script from "./CountriesPage.vue?vue&type=script&lang=js&"
export * from "./CountriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports